import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import BuildComponent from './../Components/BuildComponent.jsx';
import {
  annotations as annotationActions,
  builds as buildActions,
  dispatchers as dispatcherActions,
  fetchJobBuilds,
  fetchJobLabels,
  fetchLatestImageBaselines,
  jira as jiraActions,
  jobRelationships as jobRelationshipActions,
  jobs as jobActions,
  metrics as metricsActions,
  params as paramActions
} from './../actions';
import {
  getAllBuildPageJobs,
  getAllBuildPageBuilds,
  getJobRelationshipsChildJobIds,
  releaseBuildsPresentForProducts
} from './../reducers';
import { auth, build as buildConstants } from './../helpers';
export class BuildContainer extends Component {
  static propTypes = {
    fetchBuilds: PropTypes.func.isRequired,
    fetchRecentDispatchers: PropTypes.func.isRequired,
    fetchBuildAnnotations: PropTypes.func.isRequired,
    fetchMetricsByJobIds: PropTypes.func.isRequired,
    fetchJobsByBuildIds: PropTypes.func.isRequired,
    fetchJobBuilds: PropTypes.func.isRequired,
    fetchJobLabels: PropTypes.func.isRequired,
    fetchJobRelationshipsByJobIds: PropTypes.func.isRequired,
    fetchParamsByJobIds: PropTypes.func.isRequired,
    fetchLatestImageBaselines: PropTypes.func.isRequired,
    refreshScans: PropTypes.func.isRequired,
    builds: PropTypes.array,
    jobs: PropTypes.array,
    isAuthenticated: PropTypes.bool.isRequired,
    jobRelationshipChildJobIds: PropTypes.array.isRequired,
    releaseBuildPresent: PropTypes.bool.isRequired
  };

  componentDidMount() {
    this.props.fetchBuilds(buildConstants.FETCH_DAYS);
    this.props.fetchBuildAnnotations();
    this.props.fetchJobBuilds(buildConstants.FETCH_DAYS);
    this.props.fetchRecentDispatchers(buildConstants.FETCH_DAYS);
    this.props.fetchLatestImageBaselines();
    this.props.refreshScans();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.builds &&
      this.props.builds.length > 0 &&
      this.props.builds !== prevProps.builds
    ) {
      this.props.fetchJobsByBuildIds(this.props.builds.map(b => b.id));
    }
    if (
      this.props.jobs &&
      this.props.jobs.length > 0 &&
      this.props.jobs !== prevProps.jobs ||
      this.props.jobRelationshipChildJobIds !== prevProps.jobRelationshipChildJobIds)
    {
      const jobIds = this.props.jobs.map(j => j.id);
      this.props.fetchParamsByJobIds(jobIds);
      this.props.fetchJobLabels(jobIds);
      this.props.fetchJobRelationshipsByJobIds(jobIds);
      this.props.fetchMetricsByJobIds(
        jobIds.concat(this.props.jobRelationshipChildJobIds));
    }
  }

  render() {
    return (
      <BuildComponent isAuthenticated={this.props.isAuthenticated}
        releaseBuildPresent={this.props.releaseBuildPresent}
      />
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    builds: getAllBuildPageBuilds(state),
    jobs: getAllBuildPageJobs(state),
    isAuthenticated: auth.checkAuthenticated(),
    jobRelationshipChildJobIds: getJobRelationshipsChildJobIds(state),
    releaseBuildPresent: releaseBuildsPresentForProducts(state)
  };
};

export default connect(
  mapStateToProps,
  {
    fetchBuilds: buildActions.fetchBuilds,
    fetchRecentDispatchers: dispatcherActions.fetchRecentDispatchers,
    fetchMetricsByJobIds: metricsActions.fetchMetricsByJobIds,
    fetchJobsByBuildIds: jobActions.fetchJobsByBuildIds,
    fetchJobBuilds,
    fetchJobLabels,
    fetchJobRelationshipsByJobIds: jobRelationshipActions.fetchJobRelationshipsByJobIds,
    fetchParamsByJobIds: paramActions.fetchParamsByJobIds,
    fetchLatestImageBaselines,
    refreshScans: jiraActions.refreshScans,
    fetchBuildAnnotations: annotationActions.fetchBuildAnnotations
  }
)(BuildContainer);


// WEBPACK FOOTER //
// src/Containers/BuildContainer.jsx